export enum Images {
  ARROW_RIGHT,
  GO_ARROW,
  TG,
  VK,
  GH,
  NOTION,
  MENU
}
